// SHOULD MATCH IN FE AND API REPOS
import { z } from 'zod';

export type CreatePayment = z.infer<typeof CreatePaymentSchema>;

export const CreatePaymentSchema = z.object({
  description: z.string().optional(),
  price: z.number(),
  items: z.array(
    z.object({
      name: z.string(),
      description: z.string(),
      price: z.number(),
    })
  ),
  firstName: z.string().min(2),
  lastName: z.string().min(2),
  email: z.string().email(),
  phone: z.string().min(10),
  dueDate: z.date().transform((val) => val.getTime()),
});
